module.exports = __webpack_public_path__ + "img/3.ca7af860.png";